import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";

export const useRefetchCandidacyScoreChanges = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ candidacyId }: { candidacyId: string }) => {
    void queryClient.refetchQueries({
      queryKey: [
        "candidacy_score_changes",
        currentCompanyId,
        currentJobId,
        candidacyId,
      ],
    });
  };
};
